import 'simplebar/dist/simplebar.min.css';
import { createApp ,nextTick } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
 
import apiClient from "./plugins/axios";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';     
import Autocomplete from '@/components/Autocomplete.vue';
// import Vue3SimpleTypeahead from 'vue3-simple-typeahead';
// import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';


// axios.defaults.baseURL = 'https://vms.dktsoft.in/backend/index.php/api';
// axios.defaults.headers.common['Authorization'] = (localStorage['token'])?localStorage['token']:'na';
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const app = createApp(App);
// app.config.globalProperties.$apiname = 'https://hdvms.site/backend/index.php/api';
// app.config.globalProperties.$hostname = 'https://hdvms.site/backend/';
// app.config.globalProperties.$api_host = 'http://hdvms.site/';
// app.config.globalProperties.$cur_host = 'https://hdvms.site/';//'http://157.173.221.162:8082/';

// app.config.globalProperties.$apiname = 'https://vms.dktsoft.in/backend/index.php/api';
// app.config.globalProperties.$hostname = 'https://vms.dktsoft.in/backend/';
// app.config.globalProperties.$api_host = 'http://vps.dktsoft.in/';
// app.config.globalProperties.$cur_host = 'https://vps.dktsoft.in/'; 





app.config.globalProperties.$apiname = 'https://securevisit.in/backend/index.php/api';
app.config.globalProperties.$hostname = 'https://securevisit.in/backend/';
app.config.globalProperties.$api_host = 'https://securevisit.in/';
app.config.globalProperties.$cur_host = 'https://securevisit.in/';

// app.config.globalProperties.$cur_host = 'http://31.97.62.136:8096/';
// app.config.globalProperties.$cur_host = 'https://inventory.dktsoft.in/';
// app.config.globalProperties.$api_host = 'https://inventory.dktsoft.in/';
// app.config.globalProperties.$cur_host ='https://securevisit.in/'; 




app.config.globalProperties.$router_here =router;
app.config.globalProperties.$axios = apiClient;
//router.currentRoute.value.

app.config.globalProperties.$nextTick = nextTick;

app.directive('capitalize', {
  beforeMount(el, binding, vnode) {
    el.addEventListener('input', () => {
      let start = el.selectionStart;
      el.value = el.value.replace(/\b\w/g, l => l.toUpperCase());
      el.setSelectionRange(start, start);
      el.dispatchEvent(new Event('input'));
    });
  }
});

// app.component('Vue3SimpleTypeahead', Vue3SimpleTypeahead);
app.use(router);
app.use(VueSweetalert2); 
app.component('Autocomplete', Autocomplete) 
app.mount('#app');
//createApp(App).use(store).use(router).mount('#app')
